'use client';

import { createContext, useContext } from 'react';

import { Partner } from '@/types/store/reducers';

// The context will only ever be provided with a real partner,
// but typing requires us to provide a default here.
export const PartnerContext = createContext<Partner | undefined>(undefined);

// Hook to get partner from context (returns undefined if not in context)
export const usePartnerContext = (): Partner | undefined => {
	return useContext(PartnerContext);
};

export const useDefinedPartner = (): Partner => {
	const partner = useContext(PartnerContext);
	if (!partner) {
		throw new Error('Partner was requested, but it was not loaded in the context');
	}
	return partner;
};
